import { mb } from '../common/theme/mbTokens';

/** Card padding minus the icon button's own 8px. */
const ICON_CELL_EDGE_PADDING = { xs: 1, md: 1.5 };

/**
 * 8px between cells; a table's first and last cell use the card padding (20px desktop, 16px phone) so text lines up
 * with the card's other content. Icon-button cells (`noPadding`) get 8px there: the button's own 8px padding
 * completes the card padding.
 */
export const getCellInlinePadding = (index: number, count: number, noPadding?: boolean) => ({
  paddingInline: noPadding ? 0 : 1,
  ...(index === 0 && { paddingInlineStart: noPadding ? ICON_CELL_EDGE_PADDING : mb.layout.cardPadding }),
  ...(index === count - 1 && { paddingInlineEnd: noPadding ? ICON_CELL_EDGE_PADDING : mb.layout.cardPadding }),
});
